import { getCookieValue } from '@lingoda/cookie';
import { COOKIE_BEARER_EXP_KEY } from './constants';

export default () => {
    const value = getCookieValue(COOKIE_BEARER_EXP_KEY);

    return value ? new Date(+value * 1000) : undefined;
};
